// Build/publish timestamp, injected at build time via craco.config.js.
export const BUILD_TIME = process.env.REACT_APP_BUILD_TIME || null;

export function formatBuildTime() {
  if (!BUILD_TIME) return null;
  const d = new Date(BUILD_TIME);
  if (isNaN(d.getTime())) return null;
  return d.toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" });
}
